import { Route, Routes } from 'react-router-dom'
import { PickupSuccessPage, ServicePointSuccessPage, ReturnStartPage } from './pages'

export const AppRoutes = () => (
  <Routes>
    <Route path="/:portalId" element={<ReturnStartPage />} />
    <Route path="/success/pickup/:confirmationNumber" element={<PickupSuccessPage />} />
    <Route path="/success/service-point" element={<ServicePointSuccessPage />} />
  </Routes>
)
